if (!customElements.get('two-pm-ugc-gallery')) {
  customElements.define(
    'two-pm-ugc-gallery',
    class TwoPmUgcGallery extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.cards = Array.from(this.querySelectorAll('[data-video-card]'));
        this.playButtons = Array.from(this.querySelectorAll('[data-video-play]'));
        this.videos = Array.from(this.querySelectorAll('.two-pm-ugc-gallery__video'));
        this.onPlayButtonClick = this.onPlayButtonClick.bind(this);
        this.onCardClick = this.onCardClick.bind(this);
        this.onVideoPlay = this.onVideoPlay.bind(this);
        this.onVideoStop = this.onVideoStop.bind(this);

        this.playButtons.forEach((button) => button.addEventListener('click', this.onPlayButtonClick));
        this.cards.forEach((card) => card.addEventListener('click', this.onCardClick));
        this.videos.forEach((video) => {
          video.addEventListener('play', this.onVideoPlay);
          video.addEventListener('pause', this.onVideoStop);
          video.addEventListener('ended', this.onVideoStop);
        });

        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) entry.target.querySelector('video')?.pause();
              });
            },
            { threshold: 0 }
          );
          this.cards.forEach((card) => this.videoObserver.observe(card));
        }
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.playButtons.forEach((button) => button.removeEventListener('click', this.onPlayButtonClick));
        this.cards.forEach((card) => card.removeEventListener('click', this.onCardClick));
        this.videos.forEach((video) => {
          video.removeEventListener('play', this.onVideoPlay);
          video.removeEventListener('pause', this.onVideoStop);
          video.removeEventListener('ended', this.onVideoStop);
        });
        this.videoObserver?.disconnect();
        this.videoObserver = null;
        this.initialized = false;
      }

      onPlayButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const card = event.currentTarget.closest('[data-video-card]');
        const video = card?.querySelector('video');
        if (!video) return;

        this.playVideo(video, card);
      }

      onCardClick(event) {
        if (event.target.closest('[data-video-play]')) return;

        const card = event.currentTarget;
        const video = card.querySelector('video');
        if (!video) return;

        if (video.paused) {
          this.playVideo(video, card);
        } else {
          video.pause();
        }
      }

      playVideo(video, card) {
        this.videos.forEach((otherVideo) => {
          if (otherVideo !== video) otherVideo.pause();
        });

        video.play().catch(() => {
          card.classList.remove('is-playing');
        });
      }

      onVideoPlay(event) {
        const card = event.currentTarget.closest('[data-video-card]');
        const button = card?.querySelector('[data-video-play]');

        card?.classList.add('is-playing');
        button?.setAttribute('aria-label', 'Video is playing');
      }

      onVideoStop(event) {
        const card = event.currentTarget.closest('[data-video-card]');
        const button = card?.querySelector('[data-video-play]');

        card?.classList.remove('is-playing');
        button?.setAttribute('aria-label', 'Play video');
      }
    }
  );
}
